/*
 * Конверт записи журнала разговора 006 (contracts/thread-events.md §1, data-model.md А.7) и элемент пакета
 * `events.append` от коннектора (contracts/connector-protocol.md §2.3).
 */
import { z } from 'zod';
import { AgUiEvent } from './ag-ui';

export const JournalLevel = z.enum(['turn', 'thread']);
export type JournalLevel = z.infer<typeof JournalLevel>;

/** Номер разговора, хода, компьютера — uuid или безопасная строка до 64 знаков. */
export const Id = z.string().regex(/^[A-Za-z0-9._:-]{1,128}$/u);

/** Элемент пакета от коннектора: событие ещё без `seq`, его ставит сервер. */
export const JournalItem = z.strictObject({
  threadId: Id,
  itemKey: z.string().min(1).max(200),
  level: JournalLevel,
  runId: Id.nullable(),
  at: z.iso.datetime(),
  event: AgUiEvent,
});
export type JournalItem = z.infer<typeof JournalItem>;

/** Запись журнала, как её отдаёт сервер. */
export const JournalRecord = z.strictObject({
  threadId: Id,
  seq: z.number().int().min(1),
  at: z.string(),
  level: JournalLevel,
  runId: Id.nullable(),
  source: z.enum(['connector', 'server']),
  batchKey: z.string(),
  event: z.unknown(),
});
export type JournalRecord = z.infer<typeof JournalRecord>;
